export default "__VITE_ASSET__f778ad24__"